module.exports = __webpack_public_path__ + "static/img/usBottom5.9df9499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usBottom5.png
// module id = RTD7
// module chunks = 2